<h1 mat-dialog-title>{{ title }}</h1>
<hr>

<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
  <mat-dialog-content>
    <div class="row">
      <!-- Nombre del Departamento -->
      <div class="col-12 col-sm-6 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nombre Departamento</mat-label>
          <input matInput formControlName="nombreDepartamento" placeholder="Nombre Departamento"
            (blur)="form.controls['nombreDepartamento'].markAsTouched()" uppercase lettersOnly>
          <mat-error *ngIf="isValidField('nombreDepartamento')">
            {{ getFieldError('nombreDepartamento') }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Jefe del Departamento -->
      <div class="col-12 col-sm-6 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Jefe del Departamento</mat-label>
          <input
            type="text"
            matInput
            [formControl]="colaboradorControl"
            [matAutocomplete]="auto"
            placeholder="Escribe para buscar..."
            (focus)="abrirAutocomplete()"
            (blur)="colaboradorControl.markAsTouched()"
            uppercase
          />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="seleccionarColaborador($event)">
            <mat-option *ngFor="let colaborador of filteredColaboradores$ | async" [value]="colaborador">
              {{ colaborador.idColaborador }} - {{ colaborador.nombre }} {{ colaborador.apellidoPaterno }} {{ colaborador.apellidoMaterno }}
            </mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
          <mat-error *ngIf="colaboradorControl.invalid && colaboradorControl.touched">
            Este campo es obligatorio
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" class="m-1" type="submit" *ngIf="mostrarBoton">
      <i class="fa fa-save"></i> Guardar
    </button>
    <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
      <i class="fa fa-remove fa-solid"></i> Cancelar
    </button>
  </mat-dialog-actions>
</form>